import { createFileRoute } from '@tanstack/react-router'
import { SentinelDetailPage } from 'pages/facilityModel/SentinelDetailPage'
import {
  facilityModelSentinelSearchParams,
  type SentinelDetailTab,
} from 'routes/facility-model/-searchParams'

const RouteComponent = () => {
  const { sentinelId } = Route.useParams()
  const { siteId, tab } = Route.useSearch()
  const navigate = Route.useNavigate()
  const handleTabChange = (nextTab: SentinelDetailTab) =>
    void navigate({
      search: (prev) => ({ ...prev, tab: nextTab }),
      replace: true,
    })
  return (
    <SentinelDetailPage
      siteId={siteId ?? null}
      sentinelId={sentinelId}
      tab={tab ?? 'activity'}
      onTabChange={handleTabChange}
    />
  )
}

export const Route = createFileRoute('/facility-model/sentinels/$sentinelId')({
  component: RouteComponent,
  validateSearch: facilityModelSentinelSearchParams,
  staticData: {
    title: 'Sentinel',
    layout: {
      enableScrolling: false,
    },
  },
})
